import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/bar.svg'
import _imports_1 from '@/assets/images/edit-no-border.svg'
import _imports_2 from '@/assets/images/edit-hover.svg'


const _withScopeId = n => (_pushScopeId("data-v-3c4ce172"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "bar icon"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "edit",
  class: "position-absolute"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "edit active",
  class: "position-absolute"
}, null, -1))
const _hoisted_5 = { class: "wrapper-icon" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "wrapper-icon" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 2,
  href: "#",
  class: "text-decoration-none",
  "data-bs-toggle": "modal",
  "data-bs-target": "#logOut"
}
const _hoisted_13 = { class: "wrapper-icon" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "header bg-white d-flex justify-content-end align-items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  id: "icon_close",
  "data-name": "icon/close",
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: "14",
    height: "14",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Line",
    d: "M0,0,9,9",
    transform: "translate(2.5 2.5)",
    fill: "none",
    stroke: "gray",
    "stroke-miterlimit": "10",
    "stroke-width": "3"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Line-2",
    "data-name": "Line",
    d: "M9,0,0,9",
    transform: "translate(2.5 2.5)",
    fill: "none",
    stroke: "gray",
    "stroke-miterlimit": "10",
    "stroke-width": "3"
  })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "p-4 menu-mobile" }
const _hoisted_20 = { class: "avatar d-flex flex-column justify-content-center align-items-center" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "fw-bold text-center" }
const _hoisted_23 = { class: "main-menu--mobile" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["href"]
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 2,
  "data-bs-toggle": "modal",
  "data-bs-target": "#logOut"
}
const _hoisted_30 = {
  href: "#",
  class: "text-decoration-none"
}
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = ["innerHTML"]

import { computed, ComputedRef, PropType, ref, watchEffect } from 'vue'
import { MAIN_MENU_ADMIN } from '@/constants/index'
import MenuAdmin from '@/components/layouts/aside-admin/Menu.vue'
import { URL_CUSTOMER } from '@/constants/common'
import { useRoute } from 'vue-router'
import Footer from '@/components/footer-admin/index.vue'
import { useStore } from 'vuex'
import { COMMUNITY_STORE } from '@/store/constants'
import { CommunityStateTypes } from '@/store/modules/community'
import { addUserIconParams, userType } from '@/use/usePath'


export default /*#__PURE__*/_defineComponent({
  props: {
  ShowMembership: {
    type: Function as PropType<() => void | undefined>,
  },
},
  setup(__props) {

const props = __props

const route = useRoute()
const store = useStore()

const openMainMenuMobile = ref<boolean>(false)
const openMainMenu = ref<boolean>(false)

const profile = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME]?.profile)

const imageUrl = ref('')



const onClickMenuChild = (data: boolean) => {
  openMainMenuMobile.value = data
}
watchEffect(() => {
  if (typeof profile.value?.image_url !== 'string' && profile.value?.image_url) {
    imageUrl.value = URL.createObjectURL(profile.value?.image_url)
    return
  } else {
    imageUrl.value = profile.value?.image_url
  }
})

const MENU = computed<ComputedRef<Array<any>>>(() => {
  let menu = MAIN_MENU_ADMIN
  // if (route.path.includes('community')) {
  //   menu = menu.filter((e) => ![5].includes(e.id))
  // }
  return menu
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "d-lg-none",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openMainMenuMobile.value = true))
    }, _hoisted_2),
    _withDirectives(_createElementVNode("div", {
      class: "menu cursor-pointer d-none d-lg-flex position-relative justify-content-center align-items-center",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (openMainMenu.value = !openMainMenu.value))
    }, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", {
        class: _normalizeClass([openMainMenu.value ? 'active' : '', 'position-absolute main-menu'])
      }, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MENU), (menu, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: menu.id
            }, [
              (index !== _unref(MENU).length - 1 && menu.id !== 3)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: menu.to(_unref(route), _unref(route).params?.id),
                    class: "text-decoration-none",
                    target: index !== _unref(MENU).length - 1 && index !== 0 ? '_blank' : ''
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", {
                          class: "icon",
                          innerHTML: menu.icon
                        }, null, 8, _hoisted_6),
                        _createElementVNode("span", {
                          class: "icon-active",
                          innerHTML: menu.iconActive || menu.icon
                        }, null, 8, _hoisted_7),
                        _createElementVNode("span", null, _toDisplayString(menu.title), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to", "target"]))
                : (menu.id === 3)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      target: "_blank",
                      href: _unref(URL_CUSTOMER),
                      class: "text-decoration-none"
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", {
                          class: "icon",
                          innerHTML: menu.icon
                        }, null, 8, _hoisted_10),
                        _createElementVNode("span", {
                          class: "icon-active",
                          innerHTML: menu.iconActive || menu.icon
                        }, null, 8, _hoisted_11),
                        _createElementVNode("span", null, _toDisplayString(menu.title), 1)
                      ])
                    ], 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("a", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", {
                          class: "icon",
                          innerHTML: menu.icon
                        }, null, 8, _hoisted_14),
                        _createElementVNode("span", {
                          class: "icon-active",
                          innerHTML: menu.iconActive || menu.icon
                        }, null, 8, _hoisted_15),
                        _createElementVNode("span", null, _toDisplayString(menu.title), 1)
                      ])
                    ]))
            ]))
          }), 128))
        ])
      ], 2)
    ], 512), [
      [_directive_click_away, () => (openMainMenu.value = false)]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['user-panel--mobile position-fixed ', openMainMenuMobile.value ? 'active' : ''])
    }, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (openMainMenuMobile.value = false)),
          class: "cursor-pointer"
        }, _hoisted_18)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("img", {
            src: imageUrl.value ? _unref(addUserIconParams)(imageUrl.value, _unref(userType)()) : require('@/assets/images/user-empty.svg'),
            alt: "user avatar",
            class: "rounded-circle"
          }, null, 8, _hoisted_21),
          _createElementVNode("h3", _hoisted_22, _toDisplayString(_unref(profile)?.display_name), 1)
        ]),
        _createVNode(MenuAdmin, {
          class: "border-bottom",
          onOnClickMenuChild: onClickMenuChild
        }),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MENU), (menu, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: menu.id
              }, [
                (index !== _unref(MENU).length - 1 && menu.id !== 3)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: menu.to(_unref(route), _unref(route).params?.id),
                      class: "text-decoration-none",
                      target: index !== _unref(MENU).length - 1 && index !== 0 ? '_blank' : ''
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", {
                            class: "icon",
                            innerHTML: menu.icon
                          }, null, 8, _hoisted_24),
                          _createElementVNode("span", {
                            class: "icon-active",
                            innerHTML: menu.iconActive || menu.icon
                          }, null, 8, _hoisted_25),
                          _createElementVNode("span", null, _toDisplayString(menu.title), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to", "target"]))
                  : (menu.id === 3)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        target: "_blank",
                        href: _unref(URL_CUSTOMER)
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", {
                            class: "icon",
                            innerHTML: menu.icon
                          }, null, 8, _hoisted_27),
                          _createElementVNode("span", {
                            class: "icon-active",
                            innerHTML: menu.iconActive || menu.icon
                          }, null, 8, _hoisted_28),
                          _createElementVNode("span", null, _toDisplayString(menu.title), 1)
                        ])
                      ], 8, _hoisted_26))
                    : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("a", _hoisted_30, [
                          _createElementVNode("span", {
                            class: "icon",
                            innerHTML: menu.icon
                          }, null, 8, _hoisted_31),
                          _createElementVNode("span", {
                            class: "icon-active",
                            innerHTML: menu.iconActive || menu.icon
                          }, null, 8, _hoisted_32),
                          _createElementVNode("span", null, _toDisplayString(menu.title), 1)
                        ])
                      ]))
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(Footer, { ShowMembership: __props.ShowMembership }, null, 8, ["ShowMembership"])
    ], 2)
  ], 64))
}
}

})